import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue"

import { ref, watch, nextTick } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'dropdownBox',
  props: /*@__PURE__*/_mergeModels({
  // Goal: Keyword to open/close from parent
  openOn: {
    type: String,
    default: "keyword",
  },  
  // If Combobox, render dropdown at a different position
  combo: {
    type: Boolean,
    default: false,
  },
  alignRight: {
    type: Boolean,
    default: false
  }
}, {
    "modelValue": { default: "" },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const open = _useModel(__props, "modelValue");
const props = __props
const upperRef = ref(null)
const lowerRef = ref(null)
const triggerRef = ref(null)
const fusionRef = ref(null)

const newPosition = ref('');

function positionFct() {
  const triggerRect = triggerRef.value.getBoundingClientRect()
  let overflowRight
  let overflowBottom
  // Calculate viewport width & height
  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
  const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
  // Code after DOM-Rendering
  nextTick(() => {
    //DropUp
      //Top
      let uNewTop = triggerRect.top - upperRef.value.offsetHeight;
      if (!props.combo) {
        uNewTop = uNewTop + triggerRect.height;
      }
      // Left
      let uNewLeft = triggerRect.left
      overflowRight = uNewLeft + upperRef.value.offsetWidth - vw;
      uNewLeft = (overflowRight > 0) ? uNewLeft - overflowRight : uNewLeft;

    // DropDown
      // Left
      let lNewLeft = triggerRect.left;
      overflowRight = lNewLeft + lowerRef.value.offsetWidth - vw;
      lNewLeft = (overflowRight > 0) ? lNewLeft - overflowRight : lNewLeft;

      // Top  (if ComboBox -> at current position) (if pure modal -->below current element)
      let lNewTop = props.combo ? triggerRect.top : triggerRect.top + triggerRect.height;
      overflowBottom = lNewTop + lowerRef.value.offsetHeight - vh;
      uNewTop = (overflowBottom > 0) ? uNewTop - overflowBottom : uNewTop;

      // Positions
      let newLeft = Math.min(uNewLeft, lNewLeft);
      const newWidth = Math.max(upperRef.value.offsetWidth, lowerRef.value.offsetWidth);

      if (props.alignRight) {
        if (window.innerWidth < (newLeft + triggerRect.width + newWidth)) {
          newPosition.value = `top: ${uNewTop}px; right: ${newWidth}px; width: ${newWidth}px`;
        } else {
          newPosition.value = `top: ${uNewTop}px; left: ${newLeft + triggerRect.width}px; width: ${newWidth}px`;
        } 
      } else {
        newPosition.value = `top: ${uNewTop}px; left: ${newLeft}px; width: ${newWidth}px`;
      }
  })
}

watch(
  () => open.value,
  () => {
    if (open.value === props.openOn) positionFct();
  },
  { immediate: false }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({
      ref_key: "triggerRef",
      ref: triggerRef
    }, _ctx.$attrs, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = props.openOn))
    }), [
      _renderSlot(_ctx.$slots, "default")
    ], 16),
    (_openBlock(), _createBlock(_Teleport, { to: "#dropd" }, [
      (open.value === props.openOn)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-mask z-modal3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (open.value = ''))
          }, [
            _createElementVNode("div", {
              ref_key: "fusionRef",
              ref: fusionRef,
              style: _normalizeStyle([{"position":"fixed","cursor":"auto"}, newPosition.value]),
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", {
                ref_key: "upperRef",
                ref: upperRef
              }, [
                _renderSlot(_ctx.$slots, "dropup")
              ], 512),
              _createElementVNode("div", {
                ref_key: "lowerRef",
                ref: lowerRef
              }, [
                _renderSlot(_ctx.$slots, "dropd")
              ], 512)
            ], 4)
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})